import { useRef, useEffect, useState } from "react";

const Faq = () => {
  return (
    <div className="Faq-container"> {/* <= CHANGE THIS */}
    </div>
  );
};

export default Faq;